import { render } from "./ClickersByTag.vue?vue&type=template&id=b836feac&scoped=true"
import script from "./ClickersByTag.vue?vue&type=script&lang=js"
export * from "./ClickersByTag.vue?vue&type=script&lang=js"

import "./ClickersByTag.vue?vue&type=style&index=0&id=b836feac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b836feac"]])

export default __exports__